import { useCallback, useEffect, useState } from "react";
import { useIsComponentMounted } from "../../hooks/useIsComponentMounted";
import NitroService from "../../utils/nitro.service";
import NitroFilter from "../NitroFilter";

const UOMFilter = ({
  value,
  setValue,
  width,
  disabled,
  size,
  // variant,
  isMobile,
}: {
  value: string;
  setValue: (value: string) => void;
  width?: number;
  disabled?: boolean;
  size?: "small" | "medium";
  // variant?: "outlined" | "filled" | "standard";
  isMobile?: boolean;
}) => {
  const isComponentMounted = useIsComponentMounted();
  const [records, setRecords] = useState<{ label: string; value: string }[]>(
    []
  );
  const load = useCallback(async () => {
    const result = await NitroService.getUOMs();
    setRecords([
      { label: "", value: "" },
      ...result.map((r) => {
        return {
          label: r.uom,
          value: r.uom,
        };
      }),
    ]);
  }, []);

  useEffect(() => {
    if (!isComponentMounted) return;
    load();
  }, [isComponentMounted, load]);

  return (
    <div style={{ width, minWidth: width }}>
      <NitroFilter
        isMobile={isMobile}
        size={size}
        disabled={disabled}
        placeholder="Unit of measure"
        value={value}
        setValue={(v) => setValue(v)}
        data={{ options: records }}
        config={{ disableFilter: true }}
      />
    </div>
  );
};

export default UOMFilter;
